import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';

// import langPage from '@/utils/lang_page';
// import langComp from '@/utils/lang_comp';

// const isLoadCommonLang = false; // 是否加载通用多语言
// const cacheLangLoadRes = {}; // 已缓存的页面loadRes
// const cacheLangComp = {}; // 已缓存的组件code

export default {
  data() {
    return {
      dic: {}, // 字典
      dicCacheName: {}, // getDicValue() 缓存值
      dicCodeValue: {},
      dicValueName: {},
      dicCodeName: {},
      pageFormKey: 'formSearch',
      pageFormFunc: 'onPageChange',
      baseFuncView: {},
    };
  },
  computed: {
    funcView: vm => vm.baseFuncView,
  },
  methods: {
    // 生成当前时间YYYYMM字符串
    formatSrtYYYYMM: function (str) {
      const timeStr = moment().format('YYYYMM');
      const strReplace = str.replace(/YYYYMM/g, timeStr);
      return strReplace;
    },
    // 生成当前时间YYYYMMDD字符串
    formatSrtYYYYMMDD: function (str) {
      const timeStr = moment().format('YYYYMMDD');
      const strReplace = str.replace(/YYYYMMDD/g, timeStr);
      return strReplace;
    },
    // 获取登录多语言
    getLanguageCommon() {
      this.$getJSON(apis.LanguageLogin, { langKeyCode: 'portal_cloud_login_page' }).then((res) => {
        const langCode = Cookies.get('langCode') || 'CN';
        this.$i18n.setLocaleMessage(langCode, res.data || {});
      });
    },
    // 获取页面功能
    getFuncView: function (loadRes, cb) {
      loadRes = loadRes || this.$route.path;
      cb = cb || function () {};
      this.Bus.$emit('getFuncView', loadRes, (data) => {
        this.baseFuncView = data;
        cb();
      });
    },
    // 获取下拉字典 dic: { dicCode1: [{...}, {...}], dicCode2: [{...}, {...}] }
    getDictionary: function (codes, cb, key = 'dic') {
      codes.split(',').forEach((groupCode) => {
        this.$set(this[key], groupCode, {});
      });
      this.Bus.$emit('getDictionary', codes, (dic) => {
        this[key] = Object.assign(this[key], dic);
        if (cb) {
          cb(dic);
        }
      });
    },
    // 获取下拉字典 Map (获取字典map基础方法，内部使用，无需单独调用)
    getDictionaryKeyValue: function (codes, cb, props, key) {
      // 初始空对象
      this[key] = codes.split(',').reduce((per, item) => {
        per[item] = {};
        return per;
      }, {});
      props = props || { propKey: 'code', propVal: 'value' };
      this.Bus.$emit('getDictionary', codes, (dicGroup) => {
        const result = {};
        codes.split(',').forEach((code) => {
          const dicList = dicGroup[code];
          const map = {};
          dicList.forEach((obj) => {
            map[obj[props.propKey]] = obj[props.propVal];
          });
          result[code] = map;
        });
        this[key] = Object.assign(this[key], result);
        if (cb) {
          cb(result);
        }
      });
    },
    // 获取下拉字典 Map: dicCodeValue: { dicCode1: { code: value }, dicCode2: { code: value } }
    getDictionaryCodeValue: function (codes, cb) {
      this.getDictionaryKeyValue(codes, cb, { propKey: 'code', propVal: 'value' }, 'dicCodeValue');
    },
    // 获取下拉字典 Map: dicCodeName: { dicCode1: { code: value }, dicCode2: { code: value } }
    getDictionaryCodeName: function (codes, cb) {
      this.getDictionaryKeyValue(codes, cb, { propKey: 'code', propVal: 'name' }, 'dicCodeName');
    },
    // 获取下拉字典 Map: dicValueName: { dicCode1: { value: name  }, dicCode2: { value: name } }
    getDictionaryValueName: function (codes, cb) {
      this.getDictionaryKeyValue(codes, cb, { propKey: 'value', propVal: 'name' }, 'dicValueName');
    },
    // 页面字典值(value)转名称(name)
    getDicValue(groupCode, dicValue, nameKey = 'name') {
      if (!groupCode || (!dicValue && dicValue !== 0)) {
        return '';
      }
      const key = `${groupCode}_${dicValue}`;
      if (typeof this.dicCacheName[key] === 'undefined') {
        this.$set(this.dicCacheName, key, false);
        this.getDictionaryKeyValue(
          groupCode,
          (dicMaps) => {
            const dicMap = dicMaps[groupCode];
            this.dicCacheName[key] = dicMap[dicValue] || '';
          },
          { propKey: 'value', propVal: nameKey }
        );
      }
      return this.dicCacheName[key] || '';
    },

    // // 同步页面多语言
    // asyncLanguage(langs, keyCode, loadRes) {
    //   const localI18n = langPage[keyCode] || {};
    //   const diff = Object.keys(localI18n).filter(key => localI18n[key] !== langs[key]);
    //   if (diff.length) {
    //     this.$postJSON(apis.LanguageSyncView, { loadRes: loadRes, langKey: langPage[keyCode] }).then(() => {
    //       this.$message({
    //         message: '同步多语言成功',
    //         type: 'success'
    //       });
    //     });
    //   }
    // },
    // 同步组件多语言
    // asyncCompLanguage(langs, keyCode) {
    //   const localI18n = langComp[keyCode] || {};
    //   const diff = Object.keys(localI18n).filter(key => localI18n[key] !== langs[key]);
    //   if (diff.length) {
    //     this.$postJSON(apis.LanguageSyncCompApp, { appCode: 'customer-portal', groupCode: keyCode, langKey: langComp[keyCode] }).then(() => {
    //       this.$message({
    //         message: '同步多语言成功',
    //         type: 'success'
    //       });
    //     });
    //   }
    // },
    // 获取菜单下功能按钮 baseFuncView
    // getFuncView: function (loadRes, cb) {
    //   loadRes = loadRes || this.$route.path;
    //   cb = cb || function () {};
    //   const cache = this.$store.state.funcView;
    //   if (cache[loadRes]) {
    //     this.baseFuncView = cache[loadRes];
    //     cb();
    //     return;
    //   }

    //   this.$getJSON(apis.FuncView, { loadRes: loadRes }).then((res) => {
    //     this.baseFuncView = res.data;
    //     this.$store.commit('FUNCVIEW', Object.assign(cache, { [loadRes]: res.data }));
    //     cb();
    //   });
    // },
    // 表格列设置
    setColumn: function (table) {
      const column = this.$refs[table.columnRef || 'column'];
      if (column) {
        column.tableCode = table.tableCode;
        column.tableColumn = table.tableColumn;
        column.formatTable();
      }
    },
    // 表格列排序
    sortChange: function ({ prop, order }) {
      this[this.pageFormKey].orderBy = prop;
      if (order) {
        this[this.pageFormKey].orderType = order === 'ascending' ? 'asc' : 'desc';
      } else {
        this[this.pageFormKey].orderType = '';
        this[this.pageFormKey].orderBy = '';
      }
      this[this.pageFormFunc]({ page: 1 });
    },
    // 表格列过滤
    filterChange: function (value) {
      this[this.pageFormKey] = Object.assign(this[this.pageFormKey], value);
      this[this.pageFormFunc]({ page: 1 });
    },
    setSession(key, val) {
      const obj = {
        key: 'setSession',
        val,
      };
      sessionStorage.setItem(key, JSON.stringify(obj));
    },
    getSession(key) {
      const val = sessionStorage.getItem(key);
      const pattern = /^\{.*\}$/g;
      if (val && pattern.test(val)) {
        const obj = JSON.parse(val);
        if (obj && obj.key === 'setSession') {
          return obj.val;
        }
      }

      return '';
    },
  },
};
